// removed by extract-text-webpack-plugin
module.exports = {"Coconut":"#F4F7FA","container":"G34e153 Ge0b40c","accountWrap":"Gea0264","accountContainer":"G78c26f Gf02906 G55d311"};